export enum AuthorizationType {
    Login = 1,
    DigitalKey = 2,
}


// WEBPACK FOOTER //
// ./user/enums/AuthorizationType.ts